import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, StaffAvailability, StaffAvailabilityWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateStaffAvailability(): UseMutationResult<
  AxiosResponse<StaffAvailability>,
  AxiosError<ErrorMessage>,
  StaffAvailabilityWrite
> {
  const queryClient = useQueryClient();

  const mutationFn = (
    staffAvailabilityWrite: StaffAvailabilityWrite,
  ): Promise<AxiosResponse<StaffAvailability>> => {
    return client.post('staff-availability/', staffAvailabilityWrite);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries('staff-availability');
    },
  });
}
